import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IQuestionCompareResponse } from 'types/campaign';

interface ICompare {
    baseQuestion: string;
    targetQuestion: string;
}

interface IDataAnalyticsCompare {
    compare: ICompare;
    data: IQuestionCompareResponse | null;
}

const initialState: IDataAnalyticsCompare = {
    compare: {
        baseQuestion: '',
        targetQuestion: '',
    },
    data: null,
};

const dataAnalyticsCompareSlice = createSlice({
    name: 'dataAnalyticsCompare',
    initialState,
    reducers: {
        setCompare: (state, action: PayloadAction<ICompare>) => {
            state.compare = action.payload;
        },
        setDataCompareQuestion: (
            state,
            action: PayloadAction<IQuestionCompareResponse>
        ) => {
            state.data = action.payload;
        },
    },
});

export const { setCompare, setDataCompareQuestion } =
    dataAnalyticsCompareSlice.actions;

export default dataAnalyticsCompareSlice.reducer;
